module.exports = __webpack_public_path__ + "static/placeholder-145aa446e11924f037a00fb99418ebf2.jpg";